// src/pages/Industrial.jsx
import React from 'react';

export default function Industrial() {
  return (
    <section>
      <h1>Industrial Projects</h1>
      <p>Content coming soon…</p>
    </section>
  );
}
